<template>
  <div>
    <ActivityFlowCard
      card_title="Mis Enfoques (Tareas)"
      :data="taskList"
      :map-data="{ title: 'Title', qty: 'Qty' }"
      :loading="loading"
      @click-item-qty="handleClickLink"
    >
    </ActivityFlowCard>

    <rabbey-base-drawer :drawer.sync="drawer" size="80%" :title="headerTitle">
      <CardStatDrawerHeader
        :itemQuantity="itemQuantity"
        :headerTitle="headerTitle"
        :EmploySelectedName="EmploySelectedName"
        :diasTotal="diasTotal"
        :horasTotal="horasTotal"
      />
      <el-row type="flex" justify="end">
        <el-col>
          <rabbey-toolbox v-if="showFilters">
            <div class="mr-5 box">
              <!-- <span style="padding-right: 10px">Responsable de Tarea: </span> -->
              <el-select
                v-loading="loading"
                v-model="TaskResponsable"
                filterable
                clearable
                size="mini"
                placeholder="Responsable de Tarea"
                @change="handleFilterByTaskResponsible"
              >
                <el-option
                  v-for="item in TaskResponsableList"
                  :key="item.Id"
                  :label="item.Name + ' ' + item.LastName"
                  :value="item.Id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="mr-5 box">
              <!-- <span style="padding-right: 10px">Reponsable del Objetivo: </span> -->
              <el-select
                v-loading="loading"
                v-model="ObjectiveResponsable"
                filterable
                clearable
                size="mini"
                placeholder="Responsable de Objetivo"
                @change="handleChangeEmployee"
              >
                <el-option
                  v-for="item in ObjectiveResponsableList"
                  :key="item.Id"
                  :label="item.Name + ' ' + item.LastName"
                  :value="item.Id"
                >
                </el-option>
              </el-select>
            </div>
          </rabbey-toolbox>
        </el-col>
        <div
          class="mr-5 box"
          v-if="
            headerTitle.includes('Tareas') &&
            currentUser.Roles.some((r) => r.Id === 37)
          "
        >
          <el-select
            v-model="directionIdFilter"
            filterable
            clearable
            size="mini"
            placeholder="Direccion"
            width="200"
            @change="handleChangeDirection"
          >
            <el-option
              v-for="direction in directions"
              :key="direction.Id"
              :label="direction.Name"
              :value="direction.Id"
            ></el-option>
          </el-select>
        </div>
        <el-col :span="8">
          <rabbey-toolbox
            :filterables="true"
            @filter-search="search = $event"
          />
        </el-col>
      </el-row>
      <rabbey-table-3
        :stripe="true"
        v-if="!flagOption"
        :data="getDataArray()"
        :search="search"
        :columns="columns"
        :loading="loading"
        :actions="actions"
        @rtable-push-action="onPushAction"
      />
    </rabbey-base-drawer>

    <el-dialog
      title="Atencion"
      :visible.sync="centerDialogVisible"
      width="20%"
      center
    >
      <span center>¿ Esta seguro de que desea cancelar la solicitud ?</span>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="danger"
          size="mini"
          @click="centerDialogVisible = false"
          >Cancel</el-button
        >
        <el-button type="primary" size="mini" @click="CancelRequest"
          >Confirm</el-button
        >
      </span>
    </el-dialog>

    <TaskForm
      ref="taskForm"
      :visible.sync="taskDrawer"
      @update-data="onPushAction(actionRowData)"
      @update-table="updateTableData"
    ></TaskForm>

    <InternalRequestDrawer
      :drawer.sync="showDetail"
      :data="detailDataRequest"
      :append-to-body="true"
      :modal="false"
      @InternalRequestDrawerClose="closeInternalRequestDrawer"
    />
  </div>
</template>

<script>
import axios from "axios";
import ActivityFlowCard from "@/components/activity_flow/ActivityFlowCard.vue";
import { taskColumns, internalRequestColumns, requestColumns } from "@/columns";
import ColumnsDrawerTasksApprove from "@/columns/ColumnsDrawers";
import RabbeyTable3 from "@/components/RabbeyTable3.vue";
import CardStatDrawerHeader from "./../CardStatDrawerHeader.vue";
import { helperGetColumsItems } from "../utils.js";
import TaskForm from "@/views/apps/cmi/objetives/TaskForm.vue";
import InternalRequestDrawer from "@/components/internal_requests/InternalRequestDrawer.vue";
import Vue from "vue";
const vue = new Vue();

export default {
  name: "ActivityFlowTaskStatusCard",
  props: {
    employee: {
      type: [String, Number]
    },
    optionSelected: {
      type: Number
    },
    employeesSelected: {
      type: Array
    },
    refreshStat: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ActivityFlowCard,
    RabbeyTable3,
    CardStatDrawerHeader,
    TaskForm,
    InternalRequestDrawer
  },
  data() {
    return {
      mapData: { qty: "Totals", title: "PhaseName" },
      EmploySelectedName: "",
      directionIdFilter: null,
      task: {},
      taskList: [],
      directions: [],
      tasks: [],
      search: "",
      internals: [],
      items: [],
      employees: [],
      myTask: [],
      drawer: false,
      loading: false,
      showDetail: false,
      detailDataRequest: {},
      //loadData: false,
      loop: 1,
      lastOption: "",
      flagOption: false,
      isPendding: false,
      itemQuantity: 0, // Comes from child component ActivityFlowCard through the @click-item-qty event
      horasTotal: 0,
      diasTotal: 0,
      headerTitle: "",
      taskColumns,
      columns: [],
      centerDialogVisible: false,
      RowData: {},
      StatusToChange: Number,
      request: null, // cancelation token
      mapColumns: {
        InternalServiceRequest: internalRequestColumns,
        ServiceRequest: requestColumns,
        Task: ColumnsDrawerTasksApprove
      },
      taskDrawer: false,
      handleClickLinkProps: null,
      actions: [
        {
          icon: "el-icon-view",
          label: "Ver",
          command: "view-task-view-others",
          condition: (row) => row.Types != "task"
        },
        {
          icon: "el-icon-view",
          label: "Ver",
          command: "view-task-view",
          condition: (row) => row.Types == "task"
        },
        {
          icon: "el-icon-edit",
          label: "Editar",
          command: "view-task-edit",
          condition: (row) => row.Types == "task" && !row.PercentageProsposal
        },
        {
          icon: "el-icon-document",
          label: "Ver Evidencia",
          command: "view-task-evidence",
          condition: (row) =>
            row.Types == "task" && row.PercentageProsposal > 99
        },
        {
          icon: "el-icon-check",
          label: "Aprobar",
          command: "approve-task-percent",
          condition: (row) => row.PercentageProsposal
        },
        {
          icon: "el-icon-circle-close",
          label: "Cancelar",
          command: "Cancel-task",
          condition: (row) =>
            row.Type == "InternalRequest" &&
            //this.currentUser.Roles.filter((r) => {  return r.Id === 37  }).length > 0
            this.currentUser.Roles.some((r) => {
              return r.Id === 37;
            })
        },
        {
          icon: "el-icon-delete-solid",
          label: "Eliminar",
          command: "delete-task",
          condition: (row) => {
            console.log("row: ", row);
            let isValid =
              this.currentUser.EmployeeId === row.CreatedBy ||
              this.currentUser.Roles.some((r) => {
                return r.Id === 37 || this.currentUser.IsSupervisor === true;
              });
            return isValid;
          }
        }
      ],
      showFilters: false,
      FilteredByObjResponsable: false,
      FilteredByTaskResponsable: false,
      FilteredByTaskDirection: false,
      taskResponsable: 0,
      FilteredListObjective: [],
      FilteredListTask: [],
      FilteredListTaskDirection: [],
      ObjectiveResponsable: "",
      ObjectiveResponsableList: [],
      TaskResponsable: "",
      TaskResponsableList: [],
      actionRowData: null
    };
  },
  created() {
    this.getReportData();
    this.getProductivityAsync();
    this.getProductivityAsyncDeparment();
    this.getRequest();
    this.getEmployees();
    this.getDirections();
    //this.load();
  },
  watch: {
    refreshStat: async function () {
      // await this.getReportData();
    },
    employee: async function () {
      if (this.employee !== this.currentUser.EmployeeId) {
        this.loop++;
        this.tasks.splice(0, this.tasks.length);
        await this.getReportData();
        //await this.load();
      }
      if (this.loop > 1) {
        this.tasks.splice(0, this.tasks.length);
        await this.getReportData();
        //await this.load();
      }
    },
    optionSelected: async function () {
      if (this.employee !== this.currentUser.EmployeeId) {
        this.loop++;
        this.tasks.splice(0, this.tasks.length);
        await this.getReportData();
        //await this.load();
      }
      if (this.loop > 1) {
        this.tasks.splice(0, this.tasks.length);
        await this.getReportData();
        //    //await this.load();
      }
    }
  },
  methods: {
    //DATA FROM API
    getReportData() {
      if (this.request) {
        this.request; //cancel();
      }
      const axiosSource = axios.CancelToken.source();
      this.request = { cancel: axiosSource.cancel };
      this.loading = true;
      this.$http
        .get("/api/MessageApi/GetEnfoques", {
          cancelToken: axiosSource.token,
          timeout: 10 * 60 * 1000,
          params: {
            CompanyCode: this.currentCompany,
            EmployeeId: this.employee,
            OptionObjective: this.optionSelected
          }
        })
        .then((resp) => {
          this.taskList = resp.data;
          console.log("taskList: ", this.taskList);
          this.loading = false;
        })
        .catch((error) => console.error(error));
    },
    getDataArray() {
      //Si se filtra por Resp. de Objetivo y Tarea retorna filtered;
      if (this.FilteredByObjResponsable && this.FilteredByTaskResponsable) {
        const filtered = this.FilteredListObjective.filter(
          (f) => f.ResponsableId == this.taskResponsable
        );
        return filtered;
      }
      //Si se filtra solo por Resp. de Objetivo retorna FilteredListObjective;
      else if (this.FilteredByObjResponsable) {
        return this.FilteredListObjective;
      }
      //Si se filtra solo por Resp. de Tarea retorna FilteredListTask;
      else if (this.FilteredByTaskResponsable) {
        return this.FilteredListTask;
      }
      // Si se filtra por Gerencia
      else if (this.FilteredByTaskDirection) {
        return this.FilteredListTaskDirection;
      }
      //Si no se filtra con nada devuelve todo;
      else {
        return this.items;
      }
    },
    async getProductivityAsync() {
      const params = {
        EmployeeId: this.currentUser.EmployeeId,
        CompanySelected: this.currentCompany
      };
      this.$store.dispatch("productivity/GetProductivityByPersonAsync", params);
    },
    async getProductivityAsyncDeparment() {
      const params = {
        EmployeeId: this.currentUser.EmployeeId,
        CompanySelected: this.currentCompany
      };
      this.$store.dispatch(
        "productivity/GetProductivityByDeparmentAsync",
        params
      );
    },
    async getRequest() {
      const params = {
        EmployeeId: this.currentUser.EmployeeId,
        CompanySelected: this.currentUser.CompanySelected
      };
      this.$store.dispatch("productivity/GetInteralRequest", params);
    },
    // async update() {
    //   await this.HandlerEvent();
    // },
    // async loadButton() {
    //   this.loading = true;

    //   const params = {
    //     Employeeid: this.employee,
    //     CompanyID: this.currentCompany
    //   };

    //   try {
    //     const { data } = await this.$http.get("/api/CMI/Task/Enfoques", {
    //       timeout: 3 * 60 * 1000,
    //       params
    //     });

    //     this.loading = false;
    //     this.tasks = [];
    //     this.DisplayValues(data);
    //     this.myTask = data;
    //   } catch (error) {
    //     console.error(error);
    //     this.loading = false;
    //   }
    // },

    // DisplayValues(data) {
    //   this.task = [];
    //   this.tasks.push({ PhaseName: "Mis Solicitudes", Totals: data.Requests });
    //   this.tasks.push({
    //     PhaseName: "Solicitudes Externas",
    //     Totals: data.Externas
    //   });
    //   this.tasks.push({ PhaseName: "Por Aprobar", Totals: data.Pendding });
    //   this.tasks.push({ PhaseName: "Retrasadas", Totals: data.Dueds });
    //   this.tasks.push({ PhaseName: "Del Dia", Totals: data.AtDay });
    //   this.tasks.push({ PhaseName: "Semana actual", Totals: data.AtWeek });
    //   this.tasks.push({ PhaseName: "Proxima semana", Totals: data.NextWeek });
    //   this.tasks.push({ PhaseName: "Mes actual", Totals: data.AtMonth });
    //   this.tasks.push({ PhaseName: "Proximo mes", Totals: data.NextMonth });
    // },
    // async load() {
    //   this.loading = true;
    //   const params = {
    //     Employeeid: this.employee,
    //     CompanyID: this.currentCompany
    //   };
    //   const { data } = await this.$http.get("/api/CMI/Task/Enfoques", {
    //     timeout: 3 * 60 * 1000,
    //     params
    //   });

    //   this.DisplayValues(data);
    //   this.myTask = data;
    //   this.loading = false;
    // },
    // handleClick() {
    //   this.drawer = true;
    // },
    // async HandlerEvent() {
    //   let uri = "/api/CMI/Task/Enfoques/items";
    //   let params = {
    //     CompanyID: this.currentCompany,
    //     Employeeid: this.employee,
    //     option: this.lastOption
    //   };
    //   this.lastOption = params.option;
    //   const { data } = await this.$http.get(uri, {
    //     timeout: 3 * 60 * 1000,
    //     params
    //   });
    //   this.items = data;
    // },
    getDirections() {
      this.$http
        .get("/api/Directions/DirectionsByCompany", {
          params: {
            company: this.currentCompany
          }
        })
        .then((response) => {
          this.directions = response.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    handleChangeDirection(directionId) {
      if (directionId) {
        this.FilteredByTaskDirection = true;
        this.FilteredListTaskDirection = this.items.filter(
          (task) => task.DirecctionId === directionId
        );
        let horas = [];
        let dias = [];
        for (let i = 0; i < this.FilteredListTaskDirection.length; i++) {
          if (
            this.FilteredListTaskDirection[i].ShowType == "Horas" ||
            this.FilteredListTaskDirection[i].ShowType == "Hora"
          ) {
            horas.push(this.FilteredListTaskDirection[i].qty);
          } else {
            dias.push(this.FilteredListTaskDirection[i].qty);
          }
        }
        this.horasTotal = horas.reduce((a, b) => a + b, 0);
        this.diasTotal = dias.reduce((a, b) => a + b, 0);

        this.itemQuantity = this.FilteredListTaskDirection.length;
      } else {
        this.FilteredByTaskDirection = false;
        this.FilteredListTaskDirection = [];
      }
    },
    handleClickLink(props) {
      this.handleClickLinkProps = props;
      // console.log(props);
      let report = this.taskList.find((f) => f.Title === props.title);
      report = report ? report : props.report;
      let horas = [];
      let dias = [];
      if (report.Title.includes("Tareas")) {
        for (let i = 0; i < report.Task.length; i++) {
          if (
            report.Task[i].ShowType == "Horas" ||
            report.Task[i].ShowType == "Hora"
          ) {
            horas.push(report.Task[i].qty);
          } else {
            dias.push(report.Task[i].qty);
          }
        }
        this.horasTotal = horas.reduce((a, b) => a + b, 0);
        this.diasTotal = dias.reduce((a, b) => a + b, 0);
      }
      const { items, columns } = helperGetColumsItems(report, this.mapColumns);
      this.items = items;
      this.columns = columns;
      this.title = props.title;
      this.drawer = true;

      this.totalAmount = props.qty; // Gets total items to display it on the header of the drawer
      this.itemQuantity = this.items.length; // Gets total items to display it on the header of the drawer
      this.headerTitle = props.title;
      // console.log("Employees", this.employeesSelected);
      this.EmploySelectedName = this.employeesSelected.filter(
        (employee) => employee.EmployeeID === this.employee
      )[0].Name;
      if (this.title.includes("Tareas") == true) {
        this.showFilters = true;
      } else {
        this.showFilters = false;
      }
      this.clearFilers();
      this.employees.forEach((employee) => {
        this.items.forEach((task) => {
          if (employee.Id === task.ObjectiveOwnerId) {
            if (!this.ObjectiveResponsableList.includes(employee)) {
              this.ObjectiveResponsableList.push(employee);
            }
          }

          if (employee.Id === task.ResponsableId) {
            if (!this.TaskResponsableList.includes(employee)) {
              this.TaskResponsableList.push(employee);
            }
          }
        });
      });

      // this.flagOption = false;

      // this.itemQuantity = props.qty; // Gets total items to display it on the header of the drawer

      // let params = {
      //   CompanyID: this.currentCompany,
      //   Employeeid: this.employee
      // };

      // switch (props.title) {
      //   case "Semana actual":
      //     //call api and view task
      //     params.option = "week";
      //     break;
      //   case "Mes actual":
      //     //call api and view task
      //     params.option = "month";
      //     break;
      //   case "Del Dia":
      //     //call api and view task
      //     params.option = "day";
      //     break;
      //   case "Retrasadas":
      //     //call api and view task
      //     params.option = "older";
      //     break;

      //   case "Por Aprobar":
      //     //call api and view task
      //     params.option = "pedding";
      //     this.isPendding = true;
      //     break;
      //   case "Solicitudes Externas":
      //     //call api and view task
      //     this.columns = requestColumns;
      //     params.option = "Externas";
      //     break;

      //   case "Mis Solicitudes":
      //     params.option = "Mis Solicitudes";
      //     this.flagOption = true;
      //     break;
      //   case "Proxima semana":
      //     params.option = "NextWeek";
      //     break;

      //   case "Proximo mes":
      //     //call api and view task
      //     params.option = "NextMonth";
      //     break;
      //   default:
      //     this.flagOption = true;
      //     break;
      // }

      // this.lastOption = params.option;
      // this.drawer = true;
      // this.loading = true;
      // if (!this.flagOption) {
      //   this.$http
      //     .get("/api/CMI/Task/Enfoques/items", {
      //       timeout: 3 * 60 * 1000,
      //       params
      //     })
      //     .then(({ data }) => {
      //       this.items = data;
      //       this.loading = false;
      //     });
      // } else {
      //   this.$http
      //     .get("api/InternalServiceRequest/internalServiceRequestByEmployee", {
      //       timeout: 3 * 60 * 1000,
      //       params
      //     })
      //     .then(response => {
      //       this.items = response.data;
      //       this.loading = false;
      //     });
      // }
    },
    async onPushAction(action) {
      //.filter(rol => rol.Id === 37 ))
      let rowObjective;
      this.actionRowData = action;
      if (action.row.ObjetiveID) {
        let url = "/api/CMI/Objetives/getobjetiveByID";
        if (this.optionSelected == 1) {
          url = "/api/CMI/Objetives/getGanttObjetiveByID";
        }
        await this.$http
          .get(url, {
            params: {
              Id: action.row.ObjetiveID
            }
          })
          .then((response) => {
            rowObjective = response.data;
          });
      }

      this.taskDrawer = true;
      let rowData = {
        task: action.row,
        objective: rowObjective
      };
      switch (action.command) {
        case "view-task-view-others":
          this.detailDataRequest = {
            requestsId: action.row.Id,
            comments: [],
            descripcionLaga: action.row.Descripcion,
            descripcionCorta: action.row.corta,
            commentReasonToReopen: action.row.ReasonToReopen,
            Reopen: action.row.Reopen,
            evidences: []
          };

          this.showDetail = true;
          // this.$message({
          //   type: "warning",
          //   message:
          //     "Esta acción todavía no está habilitada. Disculpe los inconvenientes."
          // });
          break;
        case "view-task-view":
          this.$refs.taskForm.show(rowData, true, false, false);
          break;

        case "view-task-evidence":
          //console.log("rowData: ", rowData)
          this.$refs.taskForm.openFile(rowData.task.DocumentURL);
          this.currentAction = action.command;
          break;

        case "view-task-edit":
          this.$refs.taskForm.show(rowData, false, false, true);
          break;

        case "approve-task-percent":
          this.AcceptedValue(rowData.task);
          break;

        case "Cancel-task":
          this.RowData = action;
          this.StatusToChange = 4;
          //this.CancelRequest(action, 4);
          this.centerDialogVisible = true;
          break;

        case "delete-task":
          console.log("cono: ", action);

          this.$confirm(
            "Borraras la tarea seleccionada. Deseas continuar?",
            "Warning",
            {
              confirmButtonText: "Si",
              cancelButtonText: "Cancelar",
              type: "warning"
            }
          )
            .then(async () => {
              await this.$http.delete(
                `api/CMI/Task/DeleteGanttTask?TaskID=${action.row.CombinedId}`
              );
              this.$message({
                type: "success",
                message: "Tarea Borrada con Exito"
              });
              //this.TableData = await getDelayedTasks(this);
              await this.getReportData();
              this.items = this.taskList.filter(
                (data) => data.Title === this.headerTitle
              )[0].Task;
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "Operacion Cancelada"
              });
            });

          break;
      }
    },
    closeInternalRequestDrawer() {
      this.showDetail = false;
    },
    //Metodo para cambiar el status de la solicitud a cancelada
    CancelRequest() {
      /*
        console.log("Se ha cancelado la solicitud ");
         this.$message({
          message: 'Se ha cancelado la solicitud exitosamente"',
          type: 'success',
          center: true
        });
        */

      this.$http
        .get("/api/InternalServiceRequest/SetStatusInRequestByTecnical", {
          params: {
            internalRequestId: this.RowData.row.Id,
            status: this.StatusToChange,
            userId: this.currentUser.EmployeeId
          },
          timeout: 3 * 60 * 100
        })
        .then((resp) => {
          if (resp.data) {
            this.$message({
              type: "success",
              message: "Se ha cancelado la solicitud de forma exitosa!",
              center: true
            });
          } else {
            this.$message.error("Error al tratar de cancelar la solcitud");
          }
        })
        .catch((error) => {
          console.error(error);
          this.$message.error("Error al establecer Estado de la solcitud");
        })
        .finally(() => {
          const RowIndex = this.items.findIndex(
            (Row) => Row.Id == this.RowData.row.Id
          );
          this.items.splice(RowIndex, 1);
        });

      this.centerDialogVisible = false;
    },

    //MÉTODO PARA APROBAR SI PUEDE APROBAR ESTE PORCENTAJE
    AcceptedValue(row) {
      /*const { ResponsableId } = row;
      const { ID } = row;
      const RequesterId = this.currentUser.EmployeeId;
      this.$http
        .post(
          `/api/CMI/Task/canchangeTask?requesterId=${RequesterId}&ResponsableId=${ResponsableId}&TaskId=${ID}`
        )
        .then(({ data }) => {
          if (data) {
            this.SaveAfterAceptWhoCanChange(row);
          } else {
            this.$message({
              type: "info",
              message: "Usted no puede autorizar este cambio"
            });
          }
        });*/

      let TaskID = row.ID;
      let updated = false;
      vue
        .$prompt(
          "Por favor escribir un comentario de confirmación",
          "Mensaje de confirmación"
        )
        .then((result) => {
          switch (result.action) {
            case "confirm":
              if (result.value) {
                vue.$http
                  .post(`/api/cmi/task/ApproveTaskDrawer?ID=${TaskID}`)
                  .then(() => {
                    vue.$message({
                      message: "Tarea Aprobada Exitosamente",
                      type: "success"
                    });
                    updated = true;
                    vue.$emit("update-table");
                  })
                  .catch((err) => {
                    vue.$message({ type: "danger", message: err });
                  });
              } else {
                vue.$message({
                  message: "Favor introduzca un comentario válido",
                  type: "error"
                });
              }
              break;

            default:
              break;
          }
        });
      if (updated) {
        return row;
      }
    },

    //MÉTODO PARA GUARDAR COMENTARIO DE APROBACIÓN DE PORCENTAJE
    SaveAfterAceptWhoCanChange(row) {
      const apiAllow = `/api/CMI/Task/allowPercentage`;
      this.$prompt(
        "Por favor digita un comentario de confirmación",
        "Message de confirmación",
        {
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              if (instance.inputValue) {
                this.$http
                  .post(apiAllow, {
                    comment: instance.inputValue,
                    taskid: row.ID
                  })
                  .then(() => {
                    done();
                    this.getReportData();
                    var aprovedItemIndex = this.items.findIndex(
                      (item) => item.Id === row.Id
                    );
                    this.items.splice(aprovedItemIndex, 1);
                  })
                  .catch((err) => {
                    this.$message({ type: "danger", message: err });
                  });
              } else {
                this.$message({
                  type: "danger",
                  message: "Debes de digitar un comentario valido"
                });
              }
            }
            if (action === "cancel") {
              done();
            }
          }
        }
      ).catch(() => {
        this.$message({
          type: "info",
          message: "Confirmacion cancelada"
        });
      });
    },

    getEmployees() {
      let uri = "";
      const company = this.currentCompany;
      //const employeeId = this.currentUser.EmployeeId;

      // if (this.directionId > 0) {
      //   uri = `/api/Employees/GetEmployeeByCriteria?DepartmentID=${this.deparmentId}&DirectionID=${this.directionId}`;
      // } else {
      //   uri = `/api/CMI/Objetives/GetUsersObjetivos?CompanySelected=${company}&employeeid=${employeeId}`;
      // }

      uri = `/api/Employees/GetByCompany/?companyID=${company}`;

      this.$http
        .get(uri)
        .then((response) => {
          this.employees = response.data;
        })
        .catch(() => {});
    },

    handleChangeEmployee(employee) {
      if (employee) {
        this.FilteredByObjResponsable = true;
        this.FilteredListObjective = this.items.filter(
          (f) => f.ObjectiveOwnerId == employee
        );
      } else {
        this.FilteredByObjResponsable = false;
        this.FilteredListObjective = [];
      }
    },

    handleFilterByTaskResponsible(employee) {
      this.taskResponsable = employee;
      if (employee) {
        this.FilteredByTaskResponsable = true;
        this.FilteredListTask = this.items.filter(
          (f) => f.ResponsableId == employee
        );
      } else {
        this.FilteredByTaskResponsable = false;
        this.FilteredListTask = [];
      }
    },

    updateTableData() {
      this.itemQuantity--;
      var editedTaskID = this.actionRowData.row.ID;
      var taskIndex = this.items.findIndex((item) => item.ID === editedTaskID);
      this.items.splice(taskIndex, 1);
    },
    clearFilers() {
      this.handleChangeEmployee();
      this.handleFilterByTaskResponsible();
      this.ObjectiveResponsableList = [];
      this.TaskResponsableList = [];
      this.ObjectiveResponsable = "";
      this.TaskResponsable = "";
      this.FilteredListTaskDirection = [];
      this.FilteredByTaskDirection = false;
    }
  }
};
</script>
